import { LicenseManager } from 'ag-grid-enterprise';
import { ConfigurationService } from './services/http/clients/configuration.service';
import { GlobalConfigurationService } from './services/global-configuration.service';

export function initializeApp(configService: ConfigurationService, globalConfigService: GlobalConfigurationService) {
    return async (): Promise<void> => {
        try {
            const entries = await configService.getConfigurationEntries();

            await globalConfigService.setKeys(entries);

            const licenseKey = globalConfigService.getKey('grid License Key');

            if (!licenseKey) {
                throw new Error('No ag-Grid license key found in configuration');
            }

            LicenseManager.setLicenseKey(licenseKey);
        } catch (error) {
            console.error('Error loading configuration', error);
            throw new Error('Failed to initialize application configuration');
        }
    };
}
